module.exports = __webpack_public_path__ + "img/quizz-step-3-3.45b05ca6.jpg";